import React from "react";
import { connect } from "react-redux";
import Modal from "../modal"
import img_auth from '../../../../assets/images/svg/img_authorize_exception.svg';
import { LOGIN_URL_SSO } from "../../../../config/config";

const LoginExpired = ({ loginExpired }) => {
   return (
      <React.Fragment>
         {loginExpired &&
            <Modal>
               <div className="modal-dialog app-modal app-v2-modal app-modal-new model-unauthorized modal-sm" role="document">
                  <div className="modal-content" >
                     <div className="app-modal-header">
                        <h4 className="app-modal-title">
                           <div className="app-v2-modal-header">
                              <div className="custom">
                                 <div className="header-wrapper">
                                    <img className="img-warning" src={img_auth} alt="img warning login multi org" />
                                    <div className="title">Phiên đăng nhập hiện tại của bạn đã hết hạn</div>
                                 </div>
                              </div>
                              <div className="icon-wrapper">
                                 <span className="icon-close app-close">
                                    <div className="svg-next-icon ic-modal-close">
                                    </div>
                                 </span>
                              </div>
                           </div>
                        </h4>
                     </div>
                     <div className="app-modal-body">
                        <div className="body-wrapper">
                           <div className="description">Bạn cần đăng nhập lại để tiếp tục sử dụng Viettelsocial.</div>
                           <div className="app-alert-container warning alert-info">
                              <div className="app-alert-container__block">
                                 <div className="app-alert--icon">
                                    <div className="svg-next-icon ic_tri_warning" >
                                    </div>
                                 </div>
                                 <p>
                                    <b></b>
                                    <b>
                                       Lưu ý:
                                    </b>
                                    Các thao tác nhập liệu sẽ không được lưu lại.
                                 </p>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="app-modal-footer">
                        <div className="col-auto">
                           <div className="footer-wrapper">
                              <button type="button" className="app-btn app-btn-primary btn-re-login" onClick={() => {
                                 window.open(LOGIN_URL_SSO, '_self');
                              }}>
                                 Đến trang đăng nhập
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </Modal>}
      </React.Fragment>

   )
}

const mapStateToProps = (state) => {
   const { global } = state;
   return {
      loginExpired: global.loginExpired
   };
};


export default connect(mapStateToProps, {
})(LoginExpired);